var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6296 15.5954L16.873 12.8389C17.5367 11.9554 17.895 10.88 17.8937 9.775C17.8937 6.95254 15.5975 4.65625 12.775 4.65625C9.95254 4.65625 7.65625 6.95254 7.65625 9.775C7.65625 12.5975 9.95254 14.8937 12.775 14.8937C13.88 14.895 14.9554 14.5367 15.8389 13.873L18.5954 16.6296C18.7349 16.7543 18.9169 16.8209 19.104 16.8157C19.2911 16.8104 19.4691 16.7338 19.6014 16.6014C19.7338 16.4691 19.8104 16.2911 19.8157 16.104C19.8209 15.9169 19.7543 15.7349 19.6296 15.5954ZM9.11875 9.775C9.11875 9.05186 9.33318 8.34496 9.73494 7.7437C10.1367 7.14243 10.7077 6.6738 11.3758 6.39706C12.0439 6.12033 12.7791 6.04793 13.4883 6.189C14.1975 6.33008 14.849 6.6783 15.3604 7.18964C15.8717 7.70098 16.2199 8.35246 16.361 9.0617C16.5021 9.77094 16.4297 10.5061 16.1529 11.1742C15.8762 11.8423 15.4076 12.4133 14.8063 12.8151C14.205 13.2168 13.4981 13.4312 12.775 13.4312C11.8057 13.4301 10.8764 13.0445 10.1909 12.3591C9.5055 11.6736 9.11991 10.7443 9.11875 9.775Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.1af26ddeb01e3c0adec065f8042f0fcc.svg";
export { ForwardRef as ReactComponent };